import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { clearValue, setBooking, setExcess, setPhone2, setPhone3, setPickup, setStep } from "../../../Reducer/bookingSlice"
import Handler from "../../../Helpers/Components/Handler";
import { reloadWindowToPath } from "../../../Helpers/Utils";
import Modal from "../../../Helpers/Components/Modal";
import { toast } from "react-toastify";
import CustomerEdit from './CustomerEdit'
import Trip from "./Trip";
import Payment from "./Payment";
import Other from "./Other";
import Pending from "./Pending";

const Delivery = () => {
    const { id } = useParams()
    const [bookingId, setBookingId] = useState("")
    const [loading, setLoading] = useState(false)
    const booking = useSelector(state => state.booking.booking)
    const step = useSelector(state => state.booking.step)
    const [preview, setPreview] = useState(false)
    const [prev, setPrev] = useState({ delivery: 0, pickup: 0, securityDeposit: 0 })
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [dl, setDl] = useState({})
    const [aadhaar, setAadhaar] = useState({})
    const [passport, setPassport] = useState({})
    const normalizePendingPhotos = (pendingPhoto) => {
        try {
            if (!Array.isArray(pendingPhoto)) return [];
            if (
                pendingPhoto.length === 1 &&
                typeof pendingPhoto[0] === "string" &&
                pendingPhoto[0].trim().startsWith("[")
            ) {
                try {
                    const parsed = JSON.parse(pendingPhoto[0]);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    return [];
                }
            }
            return pendingPhoto;
        } catch (err) {
            return []
        }
    }
    const getBookingDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: 'get', url: `/booking/detail/${id}` })
        setLoading(false)
        if (response?.success) {
            const data = response?.data
            if (!data?.customer?.custStatus) {
                toast.error("Customer is deactive")
            }
            const mobileStatus = data?.customer?.custType === "local" ? (data?.customer?.phone?.length ? data?.customer?.phone?.filter((phone) => phone?.status)?.length >= 3 : false) : (data?.customer?.phone?.length ? data?.customer?.phone?.filter((phone) => phone?.status)?.length >= 2 : false)
            if (!mobileStatus || (data?.customer?.type === "Online" && data?.customer?.status !== "Verified")) {
                navigate(`/customer/update/${data?.customer?.customerId}`);
            }
            const pendingPhotoArray = data?.pendingPhoto?.length ? normalizePendingPhotos(data?.pendingPhoto) : []
            dispatch(setBooking({ ...response?.data?.booking, formPhoto: "", pendingPhoto: pendingPhotoArray?.length ? pendingPhotoArray?.map(element => { return { url: element, file: element } }) : [], car: data?.car, carId: data?.booking?.carId, customer: data?.customer, firstName: data?.customer?.firstName, lastName: data?.customer?.lastName, phone: data?.customer?.phone?.length ? data?.customer?.phone?.filter(e => e.priority === 1)?.length ? data?.customer?.phone?.filter(e => e.priority === 1)[0] : {} : {} }))
            setPrev({ delivery: response?.data?.booking?.deliveryDetails?.price, pickup: response?.data?.booking?.pickupDetails?.price, securityDeposit: response?.data?.booking?.securityDeposit })
            if (data?.booking?.deliveryDetails?.delivery && data?.booking?.pickupDetails?.pickup) {
                let diff = ((new Date(data?.booking?.pickupDetails?.pickup).getTime() - new Date(data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600;
                if (Math.ceil(diff / 12) / 2 == 0.5) {
                    dispatch(setBooking({ totalDays: 1, halfDayOffer: 0, point: 0 }))
                } else {
                    dispatch(setBooking({ totalDays: Math.floor(Math.ceil(diff / 12) / 2) }));
                    if (Math.ceil(diff / 12) % 2 !== 0) {
                        let to = new Date(data?.booking?.pickupDetails?.pickup)
                        to?.setHours(new Date(data?.booking?.pickupDetails?.pickup)?.getHours() - 2)
                        let diff1 = ((to?.getTime() - new Date(data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600
                        if (Math.ceil(diff1 / 12) % 2 !== 0) {
                            dispatch(setBooking({ point: 0.5 }))
                        } else {
                            dispatch(setBooking({ point: 0, halfDayOffer: 0 }))
                        }
                    } else {
                        dispatch(setBooking({ point: 0, halfDayOffer: 0 }))
                    }
                }
            }
            dispatch(setPhone2(data?.customer?.phone?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 2)?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 2)[0] : {} : {}))
            dispatch(setPhone3(data?.customer?.phone?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 3)?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 3)[0] : {} : {}))
            dispatch(setStep(Number(response?.data?.booking?.screen) > 4 ? 0 : Number(response?.data?.booking?.screen)))
            dispatch(setPickup({ pickup: new Date(data?.booking?.pickupDetails.pickup) > new Date() ? new Date() : new Date(data?.booking?.pickupDetails.pickup) }))
        } else {
            reloadWindowToPath(`/booking/1`)
        }
    }
    const updateSteps = async () => await Handler({ method: 'PATCH', url: `/booking/change/step/${bookingId}?step=${step}`, data: {} })
    const handleSubmit = async () => {
        setLoading(true);
        const formData = new FormData()
        formData.append("deactiveCar", booking?.deactiveCar)
        if (booking?.pendingPhoto?.length) {
            booking?.pendingPhoto?.map(element =>
                formData?.append('pending', element?.file || element)
            )
        }
        const response = await Handler({ method: 'patch', url: `/booking/pending/third/update/${bookingId}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
        if (response?.success) {
            setTimeout(() => {
                reloadWindowToPath(`/booking/1`)
            }, 1500);
            toast.success(response?.message)
        } else {
            setLoading(false)
            toast.error(response?.message)
        }

    }
    useEffect(() => {
        let totalAmount =
            ((Number(booking?.rentalFee || 0) -
                Number(booking?.offerPerDay || 0)) * (booking?.totalDays || 0)) +
            Number(booking?.deliveryDetails?.price || 0) + Number(booking?.pickupDetails?.price || 0) +
            Number(booking?.securityDeposit || 0)
        totalAmount += Number(booking?.point) === 0.5 ? (Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0) : 0
        dispatch(setBooking({ balancePaid: totalAmount - Number(booking?.advance?.amount || 0), totalAmount }));
    }, [booking?.rentalFee, booking?.offerPerDay, booking?.totalDays, booking?.deliveryDetails?.price, booking?.pickupDetails?.price, booking?.securityDeposit, booking?.point, booking?.halfDayOffer, booking?.advance?.amount])
    useEffect(() => {
        dispatch(clearValue())
        if (id) {
            setBookingId(id)
            getBookingDetails()
        }
    }, [id])
    useEffect(() => {
        const kmCharges = ((Number(booking?.package || 0) * Number(booking?.totalDays || 0)) + (Number(booking?.point || 0) === 0.5 ? 150 : 0)) - (Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0))
            < 0 ?
            ((Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0)) - ((Number(booking?.package || 0) * Number(booking?.totalDays || 0)) + (Number(booking?.point) === 0.5 ? 150 : 0))) * (booking?.car?.segment === "SUV" ? 10 : 7)
            : 0
        const kmDriven = (((Number(booking?.package || 0) * Number(booking?.totalDays || 0)) + (Number(booking?.point || 0) === 0.5 ? 150 : 0)) - (Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0))) < 0 ? ((Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0)) - ((Number(booking?.package || 0) * Number(booking?.totalDays || 0)) + (Number(booking?.point) === 0.5 ? 150 : 0))) : 0
        dispatch(setExcess({ kmCharges, kmDriven }))
    }, [booking?.km?.end, booking?.totalDays, booking?.package, booking?.car])
    useEffect(() => {
        let fuelConsumed = (Number(booking?.fuel?.end || 0) - Number(booking?.fuel?.start || 0)) < 0 ? (Number(booking?.fuel?.start || 0) - Number(booking?.fuel?.end || 0)) : 0
        dispatch(setExcess({ fuelConsumed, ...(fuelConsumed === 0 ? { fuelCharges: 0 } : {}) }))
    }, [booking?.fuel])
    useEffect(() => {
        if (Number(booking?.balancePaid) <= 0) {
            dispatch(setBooking({ balance: [] }))
        }
    }, [booking?.balancePaid])
    useEffect(() => {
        setDl(booking?.customer?.kyc?.length && booking?.customer?.kyc?.filter(el => el?.type === "dl")?.length ? booking?.customer?.kyc?.filter(el => el?.type === "dl")[0] : {})
        setAadhaar(booking?.customer?.kyc?.length && booking?.customer?.kyc?.filter(el => el?.type === "aadhaar")?.length ? booking?.customer?.kyc?.filter(el => el?.type === "aadhaar")[0] : {})
        setPassport(booking?.customer?.kyc?.length && booking?.customer?.kyc?.filter(el => el?.type === "passport")?.length ? booking?.customer?.kyc?.filter(el => el?.type === "passport")[0] : {})
    }, [booking])
    const initialLoad = useRef(true);
    useEffect(() => {
        if (!bookingId) return;
        if (initialLoad.current) {
            initialLoad.current = false;
            return;
        }
        updateSteps();
    }, [step]);
    return (
        <React.Fragment>
            <div className="arrow-back"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            <h5 className="text-center text-theme fs-4">Booking Update</h5>
            <h6 className="text-center">Post Booking - Pending</h6>
            <div className="layout-card mt-4">
                <div className="inside-fixed">
                <div className="text-center fs-5 mb-3 fw-bold">Status: {booking?.status}</div>
                    <div className="row">
                        <div className="text-center col-sm-4"><span className="topTitle">Booking ID : </span>{(booking?.bookingId ? booking?.bookingId : "-")}</div>
                        <div className="text-center col-sm-4"><span className="topTitle">Cust ID : </span>{(booking?.customerId ? booking?.customerId : "-")}</div>
                        <div className="text-center col-sm-4"><span className="topTitle">Booked Date : </span>{(booking?.createdAt ? moment(booking?.createdAt)?.format("DD/MM/YYYY") : "-")}</div>
                    </div>
                    <hr className="mb-5" /></div>
                <div className="row">
                    <div className="col-lg-3 d-lg-block d-flex justify-content-between mb-lg-0 mb-4 tab-col">
                        <div className="d-flex align-items-center gap-2">
                            <span className={`${step === 0 ? "active-tab" : (step > 0 ? "completed-tab" : "")} round-span`}>{step > 0 ? <i className="fa-solid fa-check"></i> : "1"}</span>
                            <div className={`register-tabs d-lg-block d-none`}>Customer Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 my-lg-4 my-0">
                            <span className={`${step === 1 ? "active-tab" : (step > 1 ? "completed-tab" : "")} round-span`}>{step > 1 ? <i className="fa-solid fa-check"></i> : "2"}</span>
                            <div className="register-tabs d-lg-block d-none">Trip Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 my-lg-4 my-0">
                            <span className={`${step === 2 ? "active-tab" : (step > 2 ? "completed-tab" : "")} round-span`}>{step > 2 ? <i className="fa-solid fa-check"></i> : "3"}</span>
                            <div className="register-tabs d-lg-block d-none">Payment Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 3 ? "active-tab" : (step > 3 ? "completed-tab" : "")} round-span`}>{step > 3 ? <i className="fa-solid fa-check"></i> : "4"}</span>
                            <div className="register-tabs d-lg-block d-none">Other Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 4 ? "active-tab" : (step > 4 ? "completed-tab" : "")} round-span`}>{step > 4 ? <i className="fa-solid fa-check"></i> : "5"}</span>
                            <div className="register-tabs d-lg-block d-none">Pending Info</div>
                        </div>
                    </div>
                    <div className="col-lg-9">
                        {
                            step === 0 ?
                                <CustomerEdit bookingId={bookingId} />
                                : step === 1 ?
                                    <Trip bookingId={bookingId} />
                                    : step === 2 ?
                                        <Payment bookingId={bookingId} prev={prev} />
                                        : step === 3 ?
                                            <Other bookingId={bookingId} />
                                            : step === 4 ?
                                                <Pending bookingId={bookingId} setPreview={setPreview} />
                                                : ""
                        }
                    </div>
                </div>
            </div>
            <Modal fullScreen={"true"} header="Preview" size={'lg'} onShow={preview} footerClassname={'justify-content-center'} toggle={() => setPreview(false)} overlayToggle={() => setPreview(false)}>
                <div className="row justify-content-center mb-3 align-items-stretch">
                    <div className="row px-3">
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Customer ID </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={booking?.customerId} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Customer Name </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.firstName || "") + " " + (booking?.lastName || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row px-3">
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Mobile </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.phone?.code || "") + "-" + (booking?.phone?.phone || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Alt Number 1 </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.phone2?.code || "") + "-" + (booking?.phone2?.phone || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Alt Number 2 </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.phone3?.code || "") + "-" + (booking?.phone3?.phone || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p-3">
                        <div className="col-lg-4">
                            <div className="form_title mb-4 text-center fw-bold"> Trip Info</div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Date and Time: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.delivery ? moment(new Date(booking?.deliveryDetails?.delivery))?.format("DD/MM/YYYY hh:mm A") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Location: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.location} readOnly />
                                </div>
                            </div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Pickup Date and Time: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.pickup ? moment(new Date(booking?.pickupDetails?.pickup))?.format("DD/MM/YYYY hh:mm A") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  Pickup Location: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.location} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Package: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.package} readOnly />
                                </div>
                            </div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Start KM: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.km?.start || 0} readOnly />
                                </div>
                            </div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > End KM: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.km?.end || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  Start Fuel: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.fuel?.start || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  End Fuel: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.fuel?.end || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  Start Fastag: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.fastTag?.start || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label">  End Fastag: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.fastTag?.end || 0} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="mt-3 mt-lg-0 col-lg-4">
                            <div className="form_title mb-3 text-center fw-bold"> Payment Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Total Days: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.totalDays + booking?.point} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Cost per day: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={(Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0)) || 0} readOnly />
                                </div>
                            </div>
                            {
                                booking?.point === 0.5 ?
                                    <div className="row mb-3">
                                        <label className="col-sm-5 col-form-label" > Half day rent: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={((Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0)) || 0} readOnly />
                                        </div>
                                    </div> : ""
                            }
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Total Cost: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={
                                        (booking?.totalDays * (Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0))) + (booking?.point === 0.5 ? (Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0) : 0) || 0
                                    } readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Charge: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.price || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Pickup Charge: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.price || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Security Deposit: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.securityDeposit || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Advance Paid: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.paid || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Advance Paid Mode: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.mode || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3 d-flex align-items-center">
                                <label className="col-sm-5 col-form-label" > Advance Paid Remarks: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.remarks || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Balance to be Paid: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.balancePaid || 0} readOnly />
                                </div>
                            </div>
                            {
                                booking?.balance?.length ?
                                    booking?.balance?.map((element, i) => {
                                        return (
                                            <div key={i}>
                                                <div className="row mb-3">
                                                    <label className="col-sm-5 col-form-label" > Balance Amount {i + 1}: </label>
                                                    <div className="col-sm-7">
                                                        <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={element?.amount || 0} readOnly />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-5 col-form-label" > Balance Paid Mode: </label>
                                                    <div className="col-sm-7">
                                                        <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={element?.mode || ""} readOnly />
                                                    </div>
                                                </div>
                                                <div className="row mb-3 d-flex align-items-center">
                                                    <label className="col-sm-5 col-form-label" > Balance Paid Remarks: </label>
                                                    <div className="col-sm-7">
                                                        <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={element?.remarks || ""} readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : ""
                            }
                        </div>
                        <div className="mt-3 mt-lg-0 col-lg-4">
                            <div className="form_title mb-3 text-center fw-bold"> Vehicle Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Car ID: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.carId || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Model: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.model || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Color: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.color || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Reg No: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.registrationNo || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Fastag Bank: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.fasTagType || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Type of Car:</label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.segment || ""} readOnly />
                                </div>
                            </div>
                            <div className="form_title mb-4 text-center fw-bold"> Excess Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess KM Driven: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.kmDriven} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess KM Charges: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.kmCharges} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess Fuel Consumed: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.fuelConsumed} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess Fuel Charges: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.fuelCharges} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess Hour Used: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.timeUsed} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess Hour Charges: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.timeCharges} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-100 text-center">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> DL  </div> </div>
                                    <div className="col"><div className={dl?.id ? "card-text" : "red card-text"}>  {dl?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : dl?.id ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> DL Photo </div> </div>
                                    <div className="col"><div className={dl?.photo?.length ? "card-text" : "red card-text"}>  {dl?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : dl?.photo?.length ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Aadhaar  </div> </div>
                                    <div className="col"><div className={aadhaar?.id ? "card-text" : "red card-text"}>  {aadhaar?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : aadhaar?.id ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Aadhaar Photo </div> </div>
                                    <div className="col"><div className={aadhaar?.photo?.length ? "card-text" : "red card-text"}>  {aadhaar?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : aadhaar?.photo?.length ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Passport </div> </div>
                                    <div className="col"><div className={passport?.id ? "card-text" : "red card-text"}>  {passport?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : passport?.id ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Passport Photo </div> </div>
                                    <div className="col"><div className={passport?.photo?.length ? "card-text" : "red card-text"}>  {passport?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : passport?.photo?.length ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-success mt-3" disabled={loading} onClick={handleSubmit}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Submit"}</button>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default Delivery;